/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Projects_DescriptionInputs */

const en_meta_projects_description = /** @type {(inputs: Meta_Projects_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore Lindevo's delivered software and clearly labelled design concepts.`)
};

const lv_meta_projects_description = /** @type {(inputs: Meta_Projects_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apskatiet Lindevo izveidoto programmatūru un skaidri norādītos dizaina konceptus.`)
};

/**
* | output |
* | --- |
* | "Explore Lindevo's delivered software and clearly labelled design concepts." |
*
* @param {Meta_Projects_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_projects_description = /** @type {((inputs?: Meta_Projects_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Projects_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_projects_description(inputs)
	return en_meta_projects_description(inputs)
});